fecharCarrinho('#modal-cart', '.modal-close');
abrirCarrinho('#modal-cart', '#modal-cart > .content-modal-cart ', '.show-modal-cart');

function abrirCarrinho(carrinho, contentModal, btnAbrirCarrinho) {
    const select = (element) => document.querySelector(element);
    const selectAll = (element) => document.querySelectorAll(element);

    selectAll(btnAbrirCarrinho).forEach(btn => {
        btn.addEventListener('click', (e) => {
            select(carrinho).classList.add('show');
            preventDefaultFecharModal(contentModal);
            $('#whats_balao').hide();
        })
    });
}

$(".show-modal").on("click", function () {
    $("#data-plan-name").html($(this).data("plan-name"));
    $(".span-download").html($(this).data("plan-download"));
    $(".span-upload").html($(this).data("plan-upload"));
    $(".span-install").html($(this).data("plan-install"));
});

$(".show-modal-cart").on("click", function () {
    $("#data-plan-name").html($(this).data("plan-name"));
    $(".span-download").html($(this).data("plan-download"));
    $(".span-upload").html($(this).data("plan-upload"));
    $(".span-install").html($(this).data("plan-install"));
});

function fecharCarrinho(carrinho, classeFecharCarrinho) {
    const select = (element) => document.querySelector(element);
    const selectAll = (element) => document.querySelectorAll(element);

    selectAll(classeFecharCarrinho).forEach(classe => {
        classe.addEventListener('click', (e) => {
            e.preventDefault();
            selectAll(carrinho).forEach(cart => cart.classList.remove('show'));
            $('#whats_balao').show();
        });
    })
}

function preventDefaultFecharModal(contentModal) {
    const select = (element) => document.querySelector(element);
    select(contentModal)?.addEventListener('click', (e) => e.stopPropagation());
}
